import type { ReactNode } from "react";

export default function SectionHead({
  kicker,
  title,
  desc,
  right,
  align = "start",
}: {
  kicker?: string;
  title: ReactNode;
  desc?: ReactNode;
  right?: ReactNode;
  align?: "start" | "center";
}) {
  return (
    <div
      className={`mb-10 md:mb-14 ${
        align === "center" ? "flex flex-col items-center text-center" : "flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between"
      }`}
    >
      <div className={align === "center" ? "flex max-w-2xl flex-col items-center text-center" : "max-w-2xl"}>
        {kicker && (
          <div className="mb-4 flex items-center gap-2">
            <span className="h-px w-6 bg-primary-400"></span>
            <span className="font-heading text-xs font-semibold tracking-[0.25em] text-primary-300">{kicker}</span>
            {align === "center" && <span className="h-px w-6 bg-primary-400"></span>}
          </div>
        )}
        <h2 className="font-heading text-2xl font-bold leading-tight text-foreground-50 md:text-4xl">{title}</h2>
        {desc && <p className="mt-4 text-sm leading-relaxed text-foreground-400 md:text-base">{desc}</p>}
      </div>
      {right && <div className="shrink-0">{right}</div>}
    </div>
  );
}